const initialDashboard = {
    dashboardLists: [],
    dashboardStatus: [],
    dashboardPermissions: {},
    changedDashboardStatus : [],
    loadingDashboard: false,
    errorsDashboard: {}
}

const  dashboardReducer = (state = initialDashboard, action) => {
    switch (action.type) {
        case "GET_DASHBOARD_PENDING":
            return { ...state, loadingDashboard: true };

        case "GET_DASHBOARD_FULFILLED":
            return {
                ...state,
                loadingDashboard: false,
                dashboardLists: action.payload,
                dashboardCount: action.dashboardCount,
                dashboardPermissions:action.permissions,
            };

        case "GET_DASHBOARD_REJECTED":
            return {
                ...state,
                loadingDashboard: false,
                errorsDashboard: action.payload
            };

        default:
            return state;
    }
}

export default dashboardReducer;
